import { inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  private router = inject(Router);

  constructor() {
    let referrer = '';
    this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        if (window['dataLayer']) {
          window['dataLayer'].push({
            event: 'page_view',
            page: e.urlAfterRedirects,
            referrer: referrer
          });
          window['dataLayer'].push({
            event: 'pageview',
            page: e.urlAfterRedirects
          });
          referrer = e.urlAfterRedirects;
        }
      }
    });
  }
}
